/* competition-terms.js  →  assets/competition-terms.js */
(function () {
  const links = document.querySelectorAll('.ct-toc__link');
  const sections = document.querySelectorAll('.ct-section');
  if (!links.length || !sections.length) return;

  const obs = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          links.forEach((l) => l.classList.remove('is-active'));
          const anchor = '#' + entry.target.id;
          const active = document.querySelector('.ct-toc__link[href="' + anchor + '"]');
          if (active) active.classList.add('is-active');
        }
      });
    },
    { rootMargin: '0px 0px -60% 0px', threshold: 0 }
  );

  sections.forEach((s) => obs.observe(s));
})();
